<template>
  <Layout class="layout--basic">
    <HeaderRoot title="Articles" :hasDocSort="true" />
    <div class="layout__wrapper">
      <vWait for="Error Loading Articles">
        <template v-slot:waiting>
          <LoadingError />
        </template>
      </vWait>
      <vWait
        class="layout__wrapper-inner layout__wrapper-inner--small-gap container"
        for="Loading Articles"
      >
        <template v-slot:waiting>
          <loading-spinner />
        </template>
        <section class="article-categories">
          <CategoriesSelection v-if="tagsView?.hasTags" :view="tagsView" />
        </section>

        <section class="docs-listing docs-listing--articles">
          <ListDocs v-if="articlesView" :view="articlesView" />
        </section>
      </vWait>
    </div>
  </Layout>
</template>

<script setup lang="ts">
import { onBeforeMount, Raw, ref } from 'vue'
import { useWait } from '@/app/composables/useWait'

import Layout from '@/app/components/Layout.vue'
import HeaderRoot from '@/app/components/header/Root.vue'

import { backend } from '@/services/backend'
import { Sentry } from '@/services/sentry'
import { ArticlesView } from '@/models/doc.article'
import CategoriesSelection from '@/app/components/listing/categories/CategoriesSelection.vue'
import ListDocs from '@/app/components/listing/ListDocs.vue'
import LoadingError from '@/components/ui/LoadingError.vue'
import vWait from 'vue-wait/src/components/v-wait.vue'
import { DocsTagsView } from '@/models/docs.tags'
import { ListView } from '@/models/docs.list'

const wait = useWait()

const articlesView = ref<Raw<ListView> | null>(null)
const tagsView = ref<Raw<DocsTagsView> | null>(null)

onBeforeMount(async () => {
  await loadArticles()
})

async function loadArticles(): Promise<void> {
  wait.start('Loading Articles')
  try {
    const response = await backend.getArticles()

    const articles = await ArticlesView.createView(response, true)
    articlesView.value = new ListView('All Articles', articles)

    tagsView.value = new DocsTagsView(response.tags, 'articles')
    wait.end('Loading Articles')
  } catch (error: any) {
    wait.start('Error Loading Articles')
    Sentry.captureException(error)
  }
}
</script>
